import { Menu } from "lucide-react";
import { C } from "../constants/colors";
import { MODULE_META, MOMENTUM_PLACEHOLDER_MODULES } from "../constants/modules";

export function PlaceholderModulePanel({ moduleId, isMobile, onMenuOpen }) {
  const meta = MODULE_META[moduleId];
  const Icon = meta?.icon;
  const message = MOMENTUM_PLACEHOLDER_MODULES[moduleId] || "Coming soon.";
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, background: "#F8F7FA", height: "100%", overflow: "hidden" }}>
      <div style={{
        background: C.indigo, padding: isMobile ? "13px 14px" : "17px 22px",
        borderBottom: `3px solid ${meta?.color || C.teal}`,
        display: "flex", alignItems: "center", gap: 10, flexShrink: 0,
      }}>
        {isMobile && (
          <button onClick={onMenuOpen} style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "10px 14px 10px 6px", display: "flex", alignItems: "center", minWidth: 44, minHeight: 44, flexShrink: 0 }}>
            <Menu size={24} />
          </button>
        )}
        <h2 style={{ color: "#fff", margin: 0, fontSize: isMobile ? 15 : 16, fontWeight: 700 }}>{meta?.label}</h2>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "40px 24px", textAlign: "center" }}>
        <div style={{
          width: 56, height: 56, borderRadius: "50%",
          background: `${meta?.color || C.teal}18`, border: `1px solid ${meta?.color || C.teal}33`,
          display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20,
        }}>
          {Icon && <Icon size={22} color={meta?.color || C.teal} />}
        </div>
        <h3 style={{ margin: "0 0 14px", fontSize: 16, fontWeight: 700, color: C.indigo }}>{meta?.label}</h3>
        <p style={{ margin: 0, fontSize: 13, color: "#666", lineHeight: 1.7, maxWidth: 360 }}>
          {message}
        </p>
      </div>
    </div>
  );
}
